"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeritextNode = void 0;
const constants_1 = require("./constants");
const ExtNode_1 = require("../../json-crdt/extensions/ExtNode");
const constants_2 = require("../constants");
class PeritextNode extends ExtNode_1.ExtNode {
    constructor() {
        super(...arguments);
        // ------------------------------------------------------------------ ExtNode
        this.extId = constants_2.ExtensionId.peritext;
    }
    text() {
        return this.data.get(0);
    }
    slices() {
        return this.data.get(1);
    }
    name() {
        return constants_1.MNEMONIC;
    }
    view() {
        return this.text().view();
    }
}
exports.PeritextNode = PeritextNode;
